import React from "react"
import autobind from "class-autobind"
import numeral from "numeral"

declare global {
    interface Window {
        Intercom: any
    }
}
interface IProps {
    optimizationSavings: number,
    optimizationText: string[],
    productivitySavings: number,
    productivityText: string[],
    administrativeSavings: number,
    administrativeText: string[],
    totalSavings: number, 
}

interface IState {
}

const containerStyle ={
    minHeight: 200, 
    background: "linear-gradient(#ffffff, #efefef)", 
    marginLeft: 10, 
    marginRight: 10, 
    borderBottomLeftRadius: 30, 
    borderBottomRightRadius: 30, 
    paddingBottom: 30,   
}

const amountClass = {
    fontSize: "11pt",
    weight: "bold",
    padding: 10,
}

const textClass = {
    fontSize: "11pt",
    lineHeight: "1em",
    textAlign: "left",
    borderLeft: "solid 5px #efefef",
    padding: 10,
}

const optimizationCellStyle = {
    borderBottom: "solid 3px #BE06F5"
}

const productivityCellStyle = {
    borderBottom: "solid 3px #05F2CD"
}

const administrativeCellStyle = {
    borderBottom: "solid 3px #187AFD"
}

const totalCellStyle = {
    borderBottom: "solid 3px #cfcfcf"
}

const sectionStyles ={
    minHeight: 60,
    display: "grid", 
    gridTemplateColumns: "81px auto"
}


export default class SubTotalCardWaveData extends React.Component<IProps, IState> {    
    constructor(props) {
        super(props)

        this.state = {
        }
        autobind(this)
    }

    render() {
        return (
            <div style={{...containerStyle}}>
                {this.props.optimizationSavings > 0 && 
                    <div style={{...sectionStyles}}>
                        <div style={{gridRow: 1, gridColumn: 1, ...amountClass, ...optimizationCellStyle}}>
                            {numeral(this.props.optimizationSavings).format('$0.0a')}
                        </div>
                        <div style={{gridRow: 1, gridColumn: 2, ...textClass, ...optimizationCellStyle}}>
                            {this.props.optimizationText.map((item, index) => <div key={index}>{item}</div>)}
                        </div>      
                    </div>     
                }

                {this.props.productivitySavings > 0 && 
                    <div style={{...sectionStyles}}>
                        <div style={{gridRow: 1, gridColumn: 1, ...amountClass, ...productivityCellStyle}}>
                            {numeral(this.props.productivitySavings).format('$0.0a')}
                        </div>
                        <div style={{gridRow: 1, gridColumn: 2, ...textClass, ...productivityCellStyle}}>
                            {this.props.productivityText.map((item, index) => <div key={index}>{item}</div>)}
                        </div>         
                    </div>     
                }

                {this.props.administrativeSavings > 0 && 
                    <div style={{...sectionStyles}}>
                        <div style={{gridRow: 1, gridColumn: 1, ...amountClass, ...administrativeCellStyle}}>
                            {numeral(this.props.administrativeSavings).format('$0.0a')}
                        </div>
                        <div style={{gridRow: 1, gridColumn: 2, ...textClass, ...administrativeCellStyle}}>
                            {this.props.administrativeText.map((item, index) => <div key={index}>{item}</div>)}
                        </div>    
                </div>     
                }

                {this.props.totalSavings > 0 && 
                    <div style={{...sectionStyles}}>
                        <div style={{gridRow: 1, gridColumn: 1, ...amountClass, ...totalCellStyle}}>
                            {numeral(this.props.totalSavings).format('$0.0a')}
                        </div>
                        <div style={{gridRow: 1, gridColumn: 2, ...textClass, ...totalCellStyle}}>
                            Total Cost Savings
                        </div>        
                    </div>   
                }
            </div>
        )
    }
}